// iOS sniffer
$(document).ready(function(){
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if( userAgent.match( /iPad/i ) || userAgent.match( /iPhone/i ) || userAgent.match( /iPod/i ) ) {
        $('html').addClass('ios-device');
    }
    else {
        $('html').addClass('not-ios');
    }

});